<template>
  <div class="content ">

    <reports-menu
        :start-date="startDate"
        :end-date="endDate"
        :show-date-piker="false"
        v-on:download="download"
    ></reports-menu>

    <div class="flex flex-wrap overflow-hidden px-8 md:px-4 pt-4 d-reports tab-donations">
      <div class="w-4/5 xl:w-4/6 md:w-full pr-5 md:pr-0">
        <div class="d-block donations-summary shadow-md rounded-md bg-white">
          <h3 class="title">{{payoutsTitle}}</h3>
          <div class="contacts-list campaign-donations-list">
            <div id="c-donations-table_wrapper" class="payouts-table-wrap">

              <el-table
                  style = "width: 100%"
                  :data = "itemsDataPage"
                  :height = "tableHeight + 195"
              >
                <template  slot="empty">
                  <div v-if="payoutsLoaded" class="empty-placeholder">
                    <img :src="require('../../assets/paceholders/9.svg')" alt="No results">
                    <h3>No Monthly Donations Yet</h3>
                  </div>
                  <div v-else slot="empty">Loading data...</div>
                </template>

                <el-table-column label="Payout Date"
                                 prop="date_paid"
                                 width="150"
                >
                  <template slot-scope="scope">
                    {{scope.row.date_paid}}
                    <div class="info">Date Paid</div>
                  </template>
                </el-table-column>

                <el-table-column label="Bank/Institution"
                                 prop="destination"
                                 min-width="250"
                >
                  <template slot-scope="scope">
                    {{scope.row.destination}}
                    <div class="info">Bank/Institution</div>
                  </template>
                </el-table-column>

                <el-table-column label="Status"
                                 min-width="130"
                >
                  <template slot-scope="scope">
                    <span class="txt-blue">Paid</span>
                    <div class="info">Status</div>
                  </template>
                </el-table-column>

                <el-table-column label="Currency"
                                 prop="amount_currency"
                                 min-width="130"
                >
                  <template slot-scope="scope">
                    {{(scope.row.amount_currency + '').toUpperCase()}}
                    <div class="info">Currency</div>
                  </template>
                </el-table-column>

                <el-table-column label="Total Amount"
                                 prop="amount_cents"
                                 sortable
                                 min-width="130"
                >
                  <template slot-scope="scope">
                    <span class="txt-blue">${{scope.row.amount_cents / 100 | formatMoney(0, 3)}}</span>
                    <div class="info">Total Amount</div>
                  </template>
                </el-table-column>

                <el-table-column label=""
                                 width="75"
                >
                  <template slot-scope="scope">

                    <el-dropdown trigger="click"
                                 @command="handleCommand"
                    >
                    <span class="el-dropdown-link inline-block text-gray-500 text-xl rounded-full h-8 w-8 flex items-center justify-center hover:bg-gray-200">
                      <font-awesome-icon :icon="['far', 'ellipsis-v']"  />
                    </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="['download', scope.row]">Download Report</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                  </template>
                </el-table-column>

              </el-table>

            </div>

          </div>
        </div>
      </div>

      <div class="w-1/5 xl:w-2/6 md:w-full">
        <div class="summary-sticky-wrap">
          <div v-if="payoutsLoaded"
               class="d-block summary summary-primary shadow-md rounded-md bg-white">
            <div class="summary-header px-6 py-4">
              <h2>Payouts</h2>
              <div class="welcome">{{payoutsTitle}}</div>
              <div class="total"><i class="just-wrap">
                <to-coins :value="totalAmount"></to-coins>
              </i></div>
            </div>
            <div class="px-6 py-4">
              <div class="welcome">Payouts Breakdown</div>
              <table class="table">
                <tbody>
                <tr>
                  <td>Payouts</td>
                  <td class="value">{{payouts.length}}</td>
                </tr>
                <tr>
                  <td>Total Amount</td>
                  <td class="value">${{totalAmount / 100 | formatMoney}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>

    <donor-info v-if="showDonorInfo"
                :donor-id="showDonorId"
                v-on:close-info="showDonorInfo = false"
    ></donor-info>
  </div>
</template>

<script>
  import {formatMoney, saveCSV} from '../../utils/utils';
  import ReportsMenu from './menu.vue';
  import DonorInfo from '../Parts/DonorInfo.vue';
  import reportsMixin from './reports-mixin';
  import reportsMenuMixin from './reports-menu-mixin';
  import {getPayoutTransactions, getRecentPayouts} from '../../utils/api';
  import ToCoins from '../Parts/ToCoins.vue';
  import dataTableMixin from '../Parts/data-table-mixin';
  import {mapState} from "vuex";

  const moment = require('moment');

  export default {
    name: 'ReportsPayouts',
    mixins: [reportsMixin, reportsMenuMixin, dataTableMixin],
    components: {
      ReportsMenu,
      DonorInfo,
      ToCoins,
    },
    metaInfo: {
      title: 'Reports - Payouts',
    },
    mounted() {
      this.updatePayouts();
      this.sorting = {prop: null, order: 'descending'};
    },
    methods: {
      handleCommand([command, payload]) {
        switch (command){
          case 'download':
            this.downloadPayout(payload.id, 'csv');
            break
        }
      },
      getPayoutById(id) {
        if (this.payoutsLoaded && this.payouts.length > 0) {
          for (let i = 0; i < this.payouts.length; i++) {
            if (this.payouts[i].id === id) {
              return this.payouts[i];
            }
          }
        }
        return null;
      },
      downloadPayout(id, type) {
        const payout = this.getPayoutById(id);
        if (!payout) {
          alert('An error has occurred, please try again.');
          return;
        }

        const title = `Payout Report for $${formatMoney(payout.amount_cents / 100, 2)} on ${payout.date_paid} - ${id}`;

        let headers = [
          'Date', 'Time', 'Description',
          'Net Donation', 'Fees Covered', 'Stripe Fee', 'Platform Fee', 'Total Gross Donation',
          'Payment Type', 'Brand', 'Exp Month', 'Exp Year', 'Last4',
          'stripe_charge_id'
        ];

        getPayoutTransactions(id).then(transactions => {

          headers = transactions.reduce((res, t) => {
            if (t.metadata && !Array.isArray(t.metadata)) {
              Object.keys(t.metadata).map(m => headers.indexOf(m) === -1 ? res.push(m) : null)
            }

            return res;
          }, headers);

          const data = transactions.map(transaction => {
            const dt = moment.unix(transaction.created_at);

            let params = [];
            headers.forEach(header => {
              switch (header) {
                case 'Date':
                  params.push(dt.format('MMM DD, YYYY'));
                  break;
                case 'Time':
                  params.push(dt.format('h:mma'));
                  break;
                case 'Description':
                  params.push(transaction.description || '');
                  break;
                case 'Net Donation':
                  params.push(transaction.net_amount && ('$' + formatMoney(transaction.net_amount / 100, 2)) || '');
                  break;
                case 'Fees Covered':
                  params.push(transaction.fee_paid_by_donor && transaction.fee_paid_by_donor || '');
                  break;
                case 'Stripe Fee':
                  params.push(transaction.stripe_fee && ('$' + formatMoney(transaction.stripe_fee / 100, 2)) || '');
                  break;
                case 'Platform Fee':
                  params.push(transaction.platform_fee && ('$' + formatMoney(transaction.platform_fee / 100, 2)) || '');
                  break;
                case 'Total Gross Donation':
                  params.push(transaction.gross_amount && ('$' + formatMoney(transaction.gross_amount / 100, 2)) || '');
                  break;
                case 'Payment Type':
                  params.push(transaction.payment_source && transaction.payment_source.type || '');
                  break;
                case 'Brand':
                  params.push(transaction.payment_source && transaction.payment_source.brand || '');
                  break;
                case 'Exp Month':
                  params.push(transaction.payment_source && transaction.payment_source.exp_month || '');
                  break;
                case 'Exp Year':
                  params.push(transaction.payment_source && transaction.payment_source.exp_year || '');
                  break;
                case 'Last4':
                  params.push(transaction.payment_source && transaction.payment_source.last4 || '');
                  break;
                case 'stripe_charge_id':
                  params.push(transaction.stripe_source_id || '');
                  break;
                default:
                  params.push(transaction.metadata && transaction.metadata[header] || '');
                  break;
              }

            });
            return params;
          });

          if (type === 'pdf') {
// eslint-disable-next-line
            let doc = new jsPDF('landscape');
            doc.text(title, 15, 20);
            doc.autoTable(
              headers,
              data, {
                margin: {top: 25},
              });
            doc.save(`${title}.pdf`);
          } else {
            saveCSV(
              [
                [title],
                headers,
                ...data,
              ],
              {
                filename: `${title}.csv`,
                addHeader: false,
              },
            );
          }
        });

      },
      download(type) {
        const title = `Payouts for ${this.activeCharityInfo && this.activeCharityInfo.charity_name || ''}`;

        const header = ['Payout Date', 'Total Amount', 'Currency', 'ID', 'Bank/Institution',];

        const body = this.itemsDataSorted.map(item => {
          return [
            item.date_paid,
            '$' + formatMoney(item.amount_cents / 100, 2, 9),
            (item.amount_currency + '').toUpperCase(),
            item.id,
            item.destination,
          ];
        });

        this.exportData(type, title, header, body);
      },
      updatePayouts() {
        getRecentPayouts().then(payouts => {

          this.payoutsLoaded = true;
          this.payouts = payouts;
        });
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      payoutsTitle() {
        if (this.payoutsLoaded && this.payouts.length > 0) {
          return `Last ${this.payouts.length} payouts`;
        }
        return 'Payouts';
      },
      totalAmount() {
        if (this.payoutsLoaded && this.payouts.length > 0) {
          return this.payouts.reduce((res, p) => res + p.amount_cents, 0);
        }
        return 0;
      },
      itemsData() {
        if (!this.payoutsLoaded) {
          return [];
        }

        return this.payouts;
      },
    },
    watch: {
      'activeCharityId'() {
        this.updatePayouts();
      },
    },
    data() {
      return {
        showDonorInfo: false,
        showDonorId: null,
        payouts: [],
        payoutsLoaded: false,
      };
    },
  };
</script>
